// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__e_jds"};